import { SET_LANGUAGE, SET_NETWORK } from "./types";

export function setLanguage(language) {
  return (dispatch) => {
    dispatch({ type: SET_LANGUAGE, payload: language });
  };
}

export function setNetwork(network) {
  return (dispatch) => {
    dispatch({ type: SET_NETWORK, payload: network });
  };
}



// WEBPACK FOOTER //
// ./frontend/redux/actions/commonAction.js